<div class="activity-log">
  <!-- Form -->
  <div class="activity-log__form">
    <form [formGroup]="form">
      <mat-form-field appearance="outline"
                      class="activity-log__form-note">
        <mat-label>Note</mat-label>
        <textarea id="activity-log__form-note"
                  matInput
                  rows="5"
                  formControlName="note"></textarea>
        <mat-error>This field is required</mat-error>
      </mat-form-field>
      <div class="activity-log__form-actions">
        <button class="activity-log__save-btn"
                id="activity-log__save-btn"
                (click)="onUpdate()"
                mat-flat-button
                color="primary"
                [disabled]="isUpdating() || form.invalid">
          <span *ngIf="!isUpdating()">Save</span>
          <mat-icon class="activity-log__save-btn--loading" *ngIf="isUpdating()">loop</mat-icon>
        </button>
      </div>
    </form>
  </div>

  <!-- Timeline -->
  <ngx-timeline [events]="events()"
                (clickEmitter)="onTimelineClick($event)"
                [groupEvent]="groupEvent"></ngx-timeline>
</div>
